import React from "react";
import "./politica-privacidade.css";

function PoliticaPrivacidade() {
  return (
    <div className="politica-page">
      <main className="politica-container">
        <header className="politica-header">
          <span className="politica-badge">ASCEND</span>

          <h1>Política de Privacidade</h1>

          <p className="politica-subtitle">
            Esta Política de Privacidade descreve como o aplicativo Ascend
            coleta, utiliza, armazena, compartilha e protege informações
            pessoais e dados relacionados à saúde de seus usuários.
          </p>

          <p className="politica-update">
            Última atualização: 15 de setembro de 2026
          </p>
        </header>

        <section>
          <h2>1. Sobre o Ascend</h2>

          <p>
            O Ascend é uma plataforma destinada a pacientes de consultório de
            nutrologia, desenvolvida para facilitar o acesso às informações
            relacionadas ao acompanhamento nutricional e aos serviços
            disponibilizados pela clínica.
          </p>

          <p>
            Por meio do aplicativo, o paciente pode consultar informações do
            seu acompanhamento, acessar dietas e exames, agendar consultas,
            interagir com outros usuários e utilizar recursos de assistência
            por inteligência artificial.
          </p>
        </section>

        <section>
          <h2>2. Funcionalidades do aplicativo</h2>

          <p>
            O Ascend disponibiliza recursos relacionados ao acompanhamento do
            paciente, incluindo:
          </p>

          <ul>
            <li>consulta ao plano alimentar e dieta;</li>
            <li>visualização de refeições e orientações nutricionais;</li>
            <li>consulta de exames e documentos relacionados à saúde;</li>
            <li>acompanhamento da evolução do paciente;</li>
            <li>agendamento e gerenciamento de consultas;</li>
            <li>recebimento de notificações;</li>
            <li>
              chat com inteligência artificial para esclarecimento de dúvidas;
            </li>
            <li>
              acesso à comunidade do Ascend, incluindo publicações, fotos,
              comentários e curtidas.
            </li>
          </ul>
        </section>

        <section>
          <h2>3. Dados que podem ser tratados</h2>

          <p>
            Para disponibilizar suas funcionalidades, o Ascend poderá tratar
            diferentes categorias de dados de acordo com os serviços utilizados
            pelo usuário.
          </p>

          <h3>3.1. Dados de cadastro</h3>

          <ul>
            <li>nome;</li>
            <li>endereço de e-mail;</li>
            <li>telefone;</li>
            <li>data de nascimento;</li>
            <li>CPF, quando necessário;</li>
            <li>foto de perfil;</li>
            <li>informações necessárias para autenticação e acesso à conta.</li>
          </ul>

          <h3>3.2. Dados relacionados à saúde</h3>

          <p>
            O Ascend pode tratar informações relacionadas à saúde do paciente,
            consideradas dados pessoais sensíveis pela legislação aplicável.
          </p>

          <p>Essas informações podem incluir:</p>

          <ul>
            <li>dietas e planos alimentares;</li>
            <li>refeições e orientações nutricionais;</li>
            <li>peso e informações de evolução corporal;</li>
            <li>massa muscular;</li>
            <li>massa de gordura;</li>
            <li>percentual de gordura corporal;</li>
            <li>IMC;</li>
            <li>resultados de exames;</li>
            <li>documentos relacionados à saúde;</li>
            <li>informações de acompanhamento nutricional;</li>
            <li>informações relacionadas ao atendimento do paciente.</li>
          </ul>

          <div className="politica-alert">
            Dados relacionados à saúde recebem tratamento especial e são
            utilizados somente para finalidades compatíveis com os serviços
            oferecidos pelo Ascend e com a legislação aplicável.
          </div>

          <h3>3.3. Consultas e agendamentos</h3>

          <p>
            Para disponibilizar as funcionalidades de agenda, poderão ser
            tratados dados como:
          </p>

          <ul>
            <li>datas e horários de consultas;</li>
            <li>profissional responsável;</li>
            <li>status do agendamento;</li>
            <li>tipo de atendimento;</li>
            <li>local de atendimento;</li>
            <li>observações relacionadas ao agendamento.</li>
          </ul>

          <h3>3.4. Chat com inteligência artificial</h3>

          <p>
            As mensagens enviadas ao chat com inteligência artificial poderão
            ser processadas para gerar respostas e auxiliar o usuário em dúvidas
            relacionadas ao acompanhamento e às funcionalidades disponíveis no
            aplicativo.
          </p>

          <p>
            Dependendo da solicitação realizada, informações pertencentes ao
            próprio paciente poderão ser utilizadas para fornecer respostas
            contextualizadas.
          </p>

          <h3>3.5. Comunidade</h3>

          <p>
            Quando o usuário utiliza a comunidade do Ascend, poderão ser
            armazenados:
          </p>

          <ul>
            <li>publicações;</li>
            <li>fotos publicadas;</li>
            <li>comentários;</li>
            <li>curtidas;</li>
            <li>identificação do responsável por cada interação.</li>
          </ul>

          <div className="politica-info">
            Conteúdos publicados na comunidade poderão ficar visíveis para
            outros usuários que tenham acesso a essa área do aplicativo.
          </div>

          <h3>3.6. Dados do dispositivo</h3>

          <p>
            Para permitir o funcionamento de determinados recursos, poderão ser
            tratados dados técnicos do dispositivo, como:
          </p>

          <ul>
            <li>token utilizado para envio de notificações;</li>
            <li>sistema operacional;</li>
            <li>modelo do dispositivo;</li>
            <li>
              informações técnicas necessárias para funcionamento e segurança
              do aplicativo.
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Como os dados são utilizados</h2>

          <p>As informações poderão ser utilizadas para:</p>

          <ul>
            <li>identificar e autenticar o usuário;</li>
            <li>permitir o acesso às funcionalidades do Ascend;</li>
            <li>disponibilizar dietas e orientações;</li>
            <li>disponibilizar exames e documentos;</li>
            <li>gerenciar consultas e agendamentos;</li>
            <li>acompanhar a evolução do paciente;</li>
            <li>responder solicitações realizadas pelo chat;</li>
            <li>permitir interações na comunidade;</li>
            <li>enviar notificações relacionadas ao aplicativo;</li>
            <li>fornecer suporte ao usuário;</li>
            <li>prevenir acessos não autorizados e fraudes;</li>
            <li>manter a segurança e funcionamento da plataforma;</li>
            <li>cumprir obrigações legais e regulatórias.</li>
          </ul>
        </section>

        <section>
          <h2>5. Dados pessoais sensíveis</h2>

          <p>
            Informações relacionadas à saúde são consideradas dados pessoais
            sensíveis.
          </p>

          <p>
            O tratamento dessas informações será realizado apenas quando
            necessário para finalidades relacionadas ao acompanhamento do
            paciente, prestação de serviços de saúde, cumprimento de obrigações
            legais, exercício regular de direitos ou outras hipóteses
            autorizadas pela legislação.
          </p>

          <p>
            Quando o consentimento for necessário, ele poderá ser solicitado ao
            usuário de maneira específica.
          </p>
        </section>

        <section>
          <h2>6. Inteligência artificial</h2>

          <p>
            O Ascend oferece um recurso de inteligência artificial destinado a
            auxiliar o usuário no esclarecimento de dúvidas.
          </p>

          <p>
            Dependendo do tipo de pergunta realizada, informações do próprio
            usuário poderão ser utilizadas para fornecer respostas mais
            contextualizadas.
          </p>

          <div className="politica-alert">
            As respostas geradas por inteligência artificial possuem caráter
            auxiliar e informativo e não substituem consulta, diagnóstico,
            prescrição ou orientação realizada por um profissional de saúde
            habilitado.
          </div>

          <p>
            Mensagens enviadas ao chat poderão ser processadas por serviços de
            tecnologia utilizados para disponibilizar a funcionalidade de
            inteligência artificial.
          </p>

          <p>
            O usuário deve evitar compartilhar informações que não sejam
            necessárias para a utilização do recurso.
          </p>
        </section>

        <section>
          <h2>7. Compartilhamento de dados</h2>

          <p>
            O Ascend não comercializa dados pessoais ou informações de saúde
            dos usuários.
          </p>

          <p>
            Informações poderão ser compartilhadas quando necessário com:
          </p>

          <ul>
            <li>
              profissionais envolvidos no acompanhamento e atendimento do
              paciente;
            </li>

            <li>
              serviços de hospedagem, servidores, banco de dados e
              infraestrutura tecnológica;
            </li>

            <li>
              serviços responsáveis pelo envio de notificações para Android e
              iOS;
            </li>

            <li>
              serviços de inteligência artificial utilizados pelo chat;
            </li>

            <li>
              fornecedores necessários para funcionamento e manutenção da
              plataforma;
            </li>

            <li>
              autoridades públicas quando houver obrigação legal ou
              determinação válida.
            </li>
          </ul>

          <p>
            O compartilhamento será limitado, sempre que possível, às
            informações necessárias para a finalidade correspondente.
          </p>
        </section>

        <section>
          <h2>8. Transferência internacional de dados</h2>

          <p>
            Alguns serviços tecnológicos utilizados pelo Ascend podem possuir
            servidores ou infraestrutura localizada fora do Brasil.
          </p>

          <p>
            Nesses casos, poderão ocorrer operações de processamento ou
            armazenamento de informações em outros países, observadas as
            medidas de proteção previstas na legislação aplicável.
          </p>
        </section>

        <section>
          <h2>9. Segurança das informações</h2>

          <p>
            O Ascend adota medidas técnicas e administrativas destinadas a
            proteger informações contra acessos não autorizados, perda,
            alteração, divulgação ou tratamento inadequado.
          </p>

          <p>Entre as medidas adotadas podem estar:</p>

          <ul>
            <li>controle de acesso;</li>
            <li>autenticação de usuários;</li>
            <li>uso de conexões seguras;</li>
            <li>restrições de acesso às informações;</li>
            <li>proteção de dados armazenados;</li>
            <li>monitoramento e procedimentos de segurança.</li>
          </ul>

          <p>
            Apesar das medidas adotadas, nenhum sistema conectado à internet
            pode garantir segurança absoluta contra todos os tipos de
            incidentes.
          </p>
        </section>

        <section>
          <h2>10. Armazenamento e retenção</h2>

          <p>
            As informações serão mantidas pelo período necessário para
            disponibilizar os serviços do Ascend e cumprir as finalidades
            descritas nesta Política de Privacidade.
          </p>

          <p>
            Determinadas informações poderão ser mantidas por período adicional
            quando houver obrigação legal, regulatória, necessidade de
            exercício regular de direitos ou outra hipótese prevista em lei.
          </p>

          <p>
            Após o término do período de retenção aplicável, os dados poderão
            ser eliminados ou anonimizados.
          </p>
        </section>

        <section id="exclusao-de-conta" className="politica-delete">
          <h2>11. Exclusão da conta e dos dados</h2>

          <p>
            O usuário poderá solicitar a exclusão de sua conta Ascend e das
            informações pessoais associadas a ela.
          </p>

          <p>
            A solicitação poderá ser realizada por meio dos canais de suporte
            disponibilizados no aplicativo ou no site do Ascend.
          </p>

          <p>
            Por motivos de segurança, poderá ser necessário confirmar a
            identidade do titular antes da conclusão da solicitação.
          </p>

          <p>
            Após a confirmação, as informações associadas à conta serão
            eliminadas, exceto quando sua conservação for necessária para
            cumprimento de obrigação legal ou regulatória, exercício regular de
            direitos ou outra hipótese permitida pela legislação.
          </p>
        </section>

        <section>
          <h2>12. Direitos do usuário</h2>

          <p>
            Nos termos da legislação aplicável, o usuário poderá exercer
            direitos relacionados aos seus dados pessoais, incluindo, quando
            aplicável:
          </p>

          <ul>
            <li>confirmação da existência de tratamento;</li>
            <li>acesso às informações pessoais;</li>
            <li>correção de informações incorretas ou desatualizadas;</li>
            <li>
              anonimização, bloqueio ou eliminação de dados quando aplicável;
            </li>
            <li>informações sobre compartilhamento de dados;</li>
            <li>revogação do consentimento quando aplicável;</li>
            <li>oposição ao tratamento quando cabível;</li>
            <li>solicitação de exclusão da conta.</li>
          </ul>

          <p>
            As solicitações poderão ser realizadas pelos canais de atendimento
            e suporte disponibilizados pelo Ascend.
          </p>
        </section>

        <section>
          <h2>13. Notificações</h2>

          <p>
            O Ascend poderá enviar notificações relacionadas às funcionalidades
            e serviços do aplicativo, incluindo informações sobre consultas,
            agendamentos, atualizações e outras comunicações pertinentes.
          </p>

          <p>
            O usuário pode alterar ou desativar as permissões de notificações
            diretamente nas configurações do seu dispositivo.
          </p>
        </section>

        <section>
          <h2>14. Crianças e adolescentes</h2>

          <p>
            Quando o Ascend for utilizado por crianças ou adolescentes, o
            tratamento das informações observará as proteções específicas
            estabelecidas pela legislação aplicável.
          </p>

          <p>
            Quando necessário, poderá ser exigida participação ou autorização
            do responsável legal.
          </p>
        </section>

        <section>
          <h2>15. Conteúdo publicado pelos usuários</h2>

          <p>
            Os usuários são responsáveis pelo conteúdo publicado na área de
            comunidade do Ascend.
          </p>

          <p>
            Recomenda-se que informações médicas, exames, documentos pessoais
            ou outros dados sensíveis não sejam publicados na comunidade, pois
            esse conteúdo poderá ser visualizado por outros usuários.
          </p>

          <p>
            Conteúdos inadequados ou que violem as regras da plataforma poderão
            ser removidos.
          </p>
        </section>

        <section>
          <h2>16. Serviços de terceiros</h2>

          <p>
            Algumas funcionalidades do Ascend dependem de tecnologias e
            serviços fornecidos por terceiros.
          </p>

          <p>
            Esses serviços poderão possuir suas próprias políticas de
            privacidade e práticas de tratamento de dados.
          </p>
        </section>

        <section>
          <h2>17. Alterações nesta Política</h2>

          <p>
            Esta Política de Privacidade poderá ser atualizada periodicamente
            para refletir alterações no aplicativo, nos serviços oferecidos ou
            na legislação aplicável.
          </p>

          <p>
            Quando ocorrer uma atualização, a data indicada no início desta
            página também será atualizada.
          </p>
        </section>

        <section>
          <h2>18. Contato e suporte</h2>

          <p>
            Dúvidas, solicitações relacionadas à privacidade, pedidos de
            correção de informações ou solicitações de exclusão de conta poderão
            ser encaminhadas através dos canais de suporte disponibilizados no
            aplicativo ou no site do Ascend.
          </p>
        </section>

        <footer className="politica-footer">
          <strong>Ascend</strong>

          <span>
            © {new Date().getFullYear()} Ascend. Todos os direitos reservados.
          </span>
        </footer>
      </main>
    </div>
  );
}

export default PoliticaPrivacidade;